import { ServerDistApi } from '@/group-cloud/network/ServerBizApi';
export class LogisticsApi {
  protected static groupUrl = '/tms';
  protected static groupUrl2 = '/wms';

  // 取消推单
  public static async cancelDriveOrderChoice(data) {
      let uri = this.groupUrl + '/order/batchCancelPush';
      return await ServerDistApi.send(uri, data);
  }    
  //物流商列表查询
  public static getLogisticsList(data) {
    let uri = this.groupUrl + '/express/list';
    return ServerDistApi.send(uri, data);
  }
  public static getAllLogisticsList(data) {
    let uri = this.groupUrl + '/express/all';
    return ServerDistApi.send(uri, data);
  }
  //物流商新增、编辑
  public static updateLogistics(data) {
    let uri = this.groupUrl + '/express/save';
    return ServerDistApi.send(uri, data);
  }
  //物流商删除
  public static deleteLogistics(data) {
    let uri = this.groupUrl + '/express/delete';
    return ServerDistApi.get(uri, data);
  }
  //运费模板列表查询
  public static getCostTemplateList(data) {
    let uri = this.groupUrl + '/frt/list';
    return ServerDistApi.send(uri, data);
  }
  //运费模板新增、编辑
  public static updateCostTemplateList(data) {
    let uri = this.groupUrl + '/frt/save';
    return ServerDistApi.send(uri, data);
  }
  //运费模板删除
  public static deleteCostTemplateList(data) {
    let uri = this.groupUrl + '/frt/delete';
    return ServerDistApi.get(uri, data);
  }

 //运费模板所有：下拉框选项
  public static getTmsFrtOptions(data) {
    let uri = this.groupUrl + '/frt/all';
    return ServerDistApi.send(uri, data);
  }
  //发货
  public static deliverOrder(data) {
    let uri = this.groupUrl + '/orderSend';
    return ServerDistApi.send(uri, data);
  }

  //发货仓库列表查询
  public static getStorehouseList(data) {
    let uri = this.groupUrl2 + '/ws/list';
    return ServerDistApi.send(uri, data);
  }
  //物流跟踪列表查询
  public static getFollowList(data) {
    let uri = this.groupUrl + '/express/orders';
    return ServerDistApi.send(uri, data);
  }
  //物流跟踪详情
  public static getFollowDetail(data) {
    let uri = this.groupUrl + '/express/trace';
    return ServerDistApi.send(uri, data);
  }
}